import { NgFor, NgIf } from '@angular/common';
import { Component, inject} from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StoredVideo } from '@shared/types';
import { DatabaseService } from '../../services/database.service';
import { on } from 'events';


@Component({
  selector: 'app-manage-videos',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatProgressSpinnerModule,
    MatIcon
  ],
  templateUrl: './manage-videos.component.html',
  styleUrl: './manage-videos.component.scss'
})
export class ManageVideosComponent {

  ready = false;

  videos: StoredVideo[] = [];


  constructor(
    private db: DatabaseService,
    private dialog: MatDialog
  ) {
    this.loadVideoList();
  }

  private async loadVideoList() {
    this.videos = await this.db.getVideos();
    this.videos.forEach( video => { if (video.on === undefined) video.on = true; });
    this.ready = true;
  };

  editRecord(index: number) {
    const data = {
      mode: 'edit',
      index: index, 
      videos: this.videos
    };
    const dialogRef = this.dialog.open(ManageVideoDialog, {data});

    dialogRef.afterClosed().subscribe(result => {
      if ( result )
        this.videos = result.videos;
    });
  }


  removeRecord(index: number) {
    const title = this.videos[index].title;
    const result = confirm(`Do you really want to remove video \'${title}\'?`);
    if ( result ) {
      this.videos.splice(index, 1);
      this.db.setVideos(this.videos);
    }
  }

  public reorderRecord(index: number, direction: 'up' | 'down') {
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    const length = this.videos.length
    if (newIndex >= 0 && newIndex < length) {
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      const movedVideo = this.videos.splice(index, 1)[0];
      this.videos.splice(newIndex, 0, movedVideo);
    }
    this.db.setVideos(this.videos);
  }


  addRecord(index: number) {
    const data = {
      mode: 'add',
      index: index, 
      videos: this.videos
    };
    const dialogRef = this.dialog.open(ManageVideoDialog, {data});
    dialogRef.afterClosed().subscribe(
      (videos: StoredVideo[] | null) => {
      if ( videos ) {
        this.videos = videos;
      }
    });
  }

}





// MANAGE-VIDEO DIALOG
@Component({
  selector: 'manage-video-dialog',
  templateUrl: 'manage-video-dialog.html',
  styleUrl: './manage-videos.component.scss',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
})
export class ManageVideoDialog {

  readonly dialogRef = inject(MatDialogRef);
  readonly data = inject<{
    mode: 'add' | 'edit',
    index: number,
    videos: StoredVideo[]
  }>(MAT_DIALOG_DATA);

  editForm: FormGroup;

  constructor(
    private db: DatabaseService,
    public formBuilder: FormBuilder
  ) {
    this.editForm = this.formBuilder.group({
      on: ['', Validators.required],
      url: ['', Validators.required],
      title: ['', Validators.required],
      author: [],
      description: ['']
    });

    if ( this.data.mode === 'edit' ) {
      const video = this.data.videos[this.data.index];
      this.editForm.setValue({
        on: video.on,
        url: video.url,
        title: video.title,
        author: video.author,
        description: video.description
      });
    }
  }

  preventSubmit(event: KeyboardEvent): void {
    if (event instanceof KeyboardEvent && event.key === 'Enter') {
      event.preventDefault(); // Impedisce il comportamento di default
    }
  }

  public async saveRecord() {
    if ( this.data.mode === 'edit') {
      const updatedVideo: StoredVideo = this.editForm.value;
      this.data.videos[this.data.index] = updatedVideo;
    } 
    else { // mode === 'add'
      const newVideo: StoredVideo = this.editForm.value;
      this.data.videos.splice(this.data.index, 0, newVideo);
    }
    await this.db.setVideos(this.data.videos)
      .then( () => {
        this.dialogRef.close(this.data.videos);
      })
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

}
